const MS_PER_SEC = 1e3;
const NS_PER_MS = 1e6;
export const now = (() => {
    if (typeof process != 'undefined' && process.hrtime) {
        return () => {
            const nowTuple = process.hrtime(); // Returns [seconds, nanoseconds]
            return nowTuple[0] * MS_PER_SEC + nowTuple[1] / NS_PER_MS;
        };
    }
    if (typeof performance != 'undefined' && performance.now) {
        return () => performance.now();
    }
    return () => Date.now();
})();
//# sourceMappingURL=now.js.map